import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getUserSellTractorSearchData,
  IGetUserSellTractorSearchParams,
  IUseGetUserSellTractorSearchDataReturn,
} from '../../../../api/userSellTractor/queries/getUserSellTractorSearchData';

interface IUseInfiniteUserSellTractorSearchDataParams {
  searchParam: IGetUserSellTractorSearchParams;
  options?: UseInfiniteQueryOptions<IUseGetUserSellTractorSearchDataReturn, AxiosError>;
}

export const useInfiniteUserSellTractorSearchData = ({
  searchParam,
  options,
}: IUseInfiniteUserSellTractorSearchDataParams) => {
  const limit = searchParam.limit || 10;

  return useInfiniteQuery<IUseGetUserSellTractorSearchDataReturn, AxiosError>(
    ['user-sell-tractor-search-data-infinite', searchParam.q, limit],
    ({ pageParam = 0 }) =>
      getUserSellTractorSearchData({
        ...searchParam,
        limit,
        offset: pageParam as number,
      }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => {
        const currentOffset = (allPages.length - 1) * limit;
        const nextOffset = currentOffset + limit;

        // 마지막 페이지의 결과가 limit보다 적으면 더 이상 페이지가 없음
        return lastPage.hits.length < limit ? undefined : nextOffset;
      },
    },
  );
};
